import React, { useEffect, useState } from "react";
import {
  getByMenu,
  postAcao,
  getUsuariosAdm,
} from "redux/actions/Screening/screeningActions";
import { connect } from "react-redux";
import {
  Button,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import auth from "services/auth";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import useEffectAfterMount from "hooks/useEffectAfterMount";
import moment from "moment";
import "moment/locale/pt-br";
import Frame from "components/Frame/Frame";
import { useLocation } from "react-router-dom";

import Search from "views/modals/pesquisar";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "authetication/authConfig";
import { getGroups } from "authetication/adal-config";
moment.locale("pt-br");
const IP1 = process.env.REACT_APP_IP1;
const IP2 = process.env.REACT_APP_IP2;
const msalInstance = new PublicClientApplication(msalConfig);

function Fluxo(props) {
  getGroups(msalInstance);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasAcess, setHasAcess] = useState(true);
  const [message, setMessage] = useState(
    "Você não tem permissão para visualizar esse relatório!"
  );
  const [menu, setMenu] = useState("");
  const [area, setArea] = useState("");
  const [hasData, setHasData] = useState(true);
  const [openSearch, setOpenSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user-profile"));
  const contentStyle = navOpen ? { width: "calc(100% - 260px)" } : {};

  const checkIp = () => {
    const ip = localStorage.getItem("ip");
    return ip === IP1 || ip === IP2;
  };
  //hooks

  useEffect(() => {
    props.getUsuariosAdm(localStorage.getItem("area"), user?.username);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isMobile && document.documentElement.classList.length === 0) {
      document.documentElement.classList.toggle("nav-open", true);
      window.dispatchEvent(new CustomEvent("toggleNav"));
      //}
    }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isNavOpen = document.documentElement.classList.contains("nav-open");
    setNavOpen(isNavOpen);
    const toggleNav = () => {
      const isNavOpen = document.documentElement.classList.contains("nav-open");
      setNavOpen(isNavOpen);
    };

    window.addEventListener("toggleNav", toggleNav);

    return () => {
      window.removeEventListener("toggleNav", toggleNav);
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchMenuData = async () => {
      try {
        setLoading(true);

        const menu = {
          params: {
            arg1: localStorage.getItem("menu"),
            arg2: localStorage.getItem("area"),
            arg3: localStorage.getItem("idMenu"),
          },
        };

        setMenu(menu.params.arg1);
        setArea(menu.params.arg2);

        // Passa o sinal do AbortController para getByMenu
        await props.getByMenu(menu, abortController.signal);

        //setLoading(false);

        let model = {
          usuario: user?.username,
          acao: `O menu ${menu.params.arg1} da área ${menu.params.arg2} foi selecionado`,
          pagina_origem: `${menu.params.arg2}`,
        };
        postAcao(model);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Erro ao buscar dados do menu:", error);
          setLoading(false);
        }
      }
    };

    fetchMenuData();

    return () => {
      abortController.abort();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, localStorage.getItem("idMenu")]);

  //effect
  useEffectAfterMount(() => {
    if (props.data.length > 0) {
      setHasData(true);
      setHasAcess(true);
      let users = props.data[0].usuarios;
      let accessControl = auth.checkUserMenu(users, props.data[0].grupos);
      if (props.data[0].confidencialAbs)
        if (!checkIp()) {
          setHasAcess(false);
          setMessage(
            "Você só pode acessar esse relatorio dentro do escritório Absolute!"
          );
        }
      if (!accessControl) {
        setHasAcess(false);
        setMessage("Você não tem permissão para visualizar esse relatório!");
      }
    } else {
      setHasData(false);
      const menuAtual = JSON.parse(localStorage.getItem("menus"))?.find(
        (item) =>
          // eslint-disable-next-line eqeqeq
          item.area == localStorage.getItem("area") &&
          // eslint-disable-next-line eqeqeq
          item.id == localStorage.getItem("idMenu")
      );
      if (menuAtual) {
        let accessControl = auth.checkUserMenu(
          menuAtual.usuarios,
          menuAtual.grupos
        );
        if (!accessControl) {
          setHasAcess(false);
          setMessage("Você não tem permissão para visualizar esse relatório!");
        } else setHasAcess(true);
      } else setHasAcess(true);
    }
    setData(groupBy(props.data, "idCard"));
    setLoading(false);
  }, [props.data]);

  const getStyle = () => {
    return {
      float: "right",
      position: isMobile ? "absolute" : "fixed",
      top: 0,
      right: 10,
      zIndex: 1000000,
    };
  };

  const groupBy = (lista, coluna1) => {
    var colunas = {};
    var resultado = [];

    lista.forEach(function (item) {
      var reg = {};
      colunas[item[coluna1]] = colunas[item[coluna1]] || [];

      for (var i in item) reg[i] = item[i];

      colunas[item[coluna1]].push(reg);
    });

    for (var i in colunas) resultado.push({ key: i, values: colunas[i] });
    resultado = resultado.map((item) => {
      item.key = Number(item.key);
      return item;
    });
    resultado = _.sortBy(resultado, function (dateObj) {
      return Number(dateObj.values[0].ordem);
    });
    // resultado.sort(function (a, b) {
    //   var keyA = Number(a.ordem),
    //     keyB = Number(b.ordem);
    //   if (keyA < keyB) return -1;
    //   if (keyA > keyB) return 1;
    //   return 0;
    // });

    resultado.forEach((x) => {
      x.values.sort(function (a, b) {
        var keyA = Number(a.ordemAba),
          keyB = Number(b.ordemAba);
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
    });
    return resultado;
  };

  const refresh = (click = true) => {
    const menu = {
      params: {
        arg1: localStorage.getItem("menu"),
        arg2: localStorage.getItem("area"),
        arg3: localStorage.getItem("idMenu"),
      },
    };
    let user = JSON.parse(localStorage.getItem("user-profile"));
    if (click) {
      let model = {
        usuario: user?.username,
        acao: `Clique no botão de refresh na área: ${menu.params.arg2} e menu: ${menu.params.arg1}`,
        pagina_origem: `${menu.params.arg2} | ${menu.params.arg1}`,
      };
      postAcao(model);
    }
    setLoading(true);
    props.getByMenu(menu);
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setOpenSearch(true);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("msal.interaction.status");
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <>
      <Search
        open={openSearch}
        setOpen={setOpenSearch}
        searchInput={search}
      ></Search>
      {hasAcess ? (
        <div id="tekfnsdj" className="content tekfnsdj" style={contentStyle}>
          {!isMobile ? (
            <div style={getStyle()}>
              <Button
                id="refresh"
                color="primary"
                className="btn-round"
                style={{
                  paddingTop: 6,
                  paddingBottom: 6,
                  marginTop: 4,
                }}
                onClick={() => {
                  refresh();
                }}
              title="Refresh"
              >
                <i style={{ fontSize: 15 }} className="nc-icon nc-refresh-69" />
              </Button>
              <Button
                id="refresh"
                //color="primary"
                className="btn-round"
                style={{
                  paddingTop: 6,
                  paddingBottom: 6,
                  marginTop: 4,
                }}
                onClick={() => {
                  handleLogout();
                }}
                title="Logout"
              >
                <i
                  className="fa fa-sign-out-alt"
                  style={{ fontSize: 15 }}
                  aria-hidden="true"
                ></i>
              </Button>
              <Form
                style={{
                  position: "absolute",
                  top: "5px",
                  transform: "translate3d(-499px, 0, 0)",
                  width: "209px",
                }}
              >
                <InputGroup className="no-border">
                  <Input
                    style={{
                      backgroundColor: "#f4f3ef",
                      height: 25,
                      minHeight: 25,
                      //color: "white",
                    }}
                    defaultValue=""
                    placeholder="Buscar..."
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={handleSearch}
                  />
                  <InputGroupAddon
                    addonType="append"
                    style={{
                      background: "#f4f3ef",
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                      cursor: "pointer",
                      height: 25,
                      minHeight: 25,
                    }}
                    onClick={() => setOpenSearch(true)}
                  >
                    <InputGroupText
                      style={{ paddingLeft: "6px" }}
                      onClick={handleSearch}
                    >
                      <i className="nc-icon nc-zoom-split" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Form>
            </div>
          ) : (
            <div style={getStyle()}>
              <Button
                id="refresh"
                color="primary"
                className="btn-round"
                style={{
                  paddingTop: 3,
                  paddingBottom: 3,
                  marginTop: 5,
                }}
                onClick={() => {
                  refresh();
                }}
                title="Refresh"
              >
                <i style={{ fontSize: 15 }} className="nc-icon nc-refresh-69" />
              </Button>
            </div>
          )}
          <Frame
            data={data}
            loading={loading}
            menu={menu}
            area={area}
            hasData={hasData}
            refresh={refresh}
            usuariosAdm={props.usuariosAdm}
            user={user}
            hasAcessReport={hasAcess}
          />
        </div>
      ) : (
        <div id="tekfnsdj" className="content tekfnsdj" style={contentStyle}>
          {!isMobile ? (
            <div style={getStyle()}>
              {/* <Button
                id="refresh"
                color="primary"
                className="btn-round"
                onClick={() => {
                  refresh();
                }}
              >
                <i style={{ fontSize: 15 }} className="nc-icon nc-refresh-69" />
              </Button> */}
              <Form
                style={{
                  position: "absolute",
                  top: "5px",
                  transform: "translate3d(-499px, 0, 0)",
                  width: "209px",
                }}
              >
                <InputGroup className="no-border">
                  <Input
                    style={{
                      backgroundColor: "#f4f3ef",
                      height: 25,
                      minHeight: 25,
                      //color: "white",
                    }}
                    defaultValue=""
                    placeholder="Buscar..."
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={handleSearch}
                  />
                  <InputGroupAddon
                    addonType="append"
                    style={{
                      background: "#f4f3ef",
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                      cursor: "pointer",
                      height: 25,
                      minHeight: 25,
                    }}
                    onClick={() => setOpenSearch(true)}
                  >
                    <InputGroupText
                      style={{ paddingLeft: "6px" }}
                      onClick={handleSearch}
                    >
                      <i className="nc-icon nc-zoom-split" />
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Form>
              <Button
                id="refresh"
                //color="primary"
                className="btn-round"
                style={{
                  paddingTop: 6,
                  paddingBottom: 6,
                  marginTop: 4,
                }}
                onClick={() => {
                  handleLogout();
                }}
                title="Logout"
              >
                <i
                  className="fa fa-sign-out-alt"
                  style={{ fontSize: 15 }}
                  aria-hidden="true"
                ></i>
              </Button>
            </div>
          ) : null}
          <div
            style={{
              justifyContent: "center",
              height: "94vh",
              display: "flex",
              alignItems: "center",
              color: "red",
            }}
          >
            <div>{message}</div>
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.screening.screening.data,
    error: state.screening.screening.error,
    loading: state.screening.screening.loading,
    usuariosAdm: state.screening.screening.usuariosAdm,
  };
};

export default connect(mapStateToProps, { getByMenu, getUsuariosAdm })(Fluxo);
